// 9fbef606107a605d69c0edbcd8029e5d
import getAllPaymentCards from '@tcp/core/src/queries/getAllPaymentCards.query.graphql';
import getAddressAndCardListAPI from '@tcp/core/src/queries/getAddressAndPaymentInstruments.query.graphql';
import logger from '@tcp/core/src/utils/loggerInstance';
import { parseBoolean } from '../../../utils/utils';
import { executeStatefulGraphQLQuery } from '../../handler';

export function formatAddressBookResponse(arr, defaultBillingId, defaultShippingId) {
  let containsDefault = false;
  const addresses = arr.map((address) => {
    containsDefault = containsDefault || parseBoolean(address.preferred);
    const defaultBilling = address;
    defaultBilling.xcont_isDefaultBilling = 'false';
    defaultBilling.preferred = 'false';
    defaultBilling.creditCard = 'false';
    if (address.addressId === defaultBillingId) {
      defaultBilling.xcont_isDefaultBilling = 'true';
    }
    if (address.addressId === defaultShippingId) {
      defaultBilling.preferred = 'true';
    }

    return {
      ...address,
    };
  });
  if (!containsDefault && addresses.length) {
    addresses[0].preferred = 'true';
  }
  return addresses;
}

export const getGiftCardListApi = () => {
  return executeStatefulGraphQLQuery({
    query: getAllPaymentCards,
    type: 'query',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger.error(err);
    });
};

export const getAddressAndCardListApi = () => {
  return executeStatefulGraphQLQuery({
    query: getAddressAndCardListAPI,
    type: 'query',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      const responseAddress = formatAddressBookResponse(
        res?.data?.getCustomer?.addresses || [],
        res?.data?.getCustomer?.billingAddressId,
        res?.data?.getCustomer?.shippingAddressId
      );
      return {
        responseAddress,
        responsePayment: res,
      };
    })
    .catch((err) => {
      logger.error(err);
    });
};
